/* ================================================== */
/* SEARCH > Events
/* ================================================== */

function searchEvents() {

	// Open modal on click
	$openCtrl.click(function() {
		openSearch();
	});

	// Close modal on click
	$closeCtrl.click(function() {
		closeSearch();
	});

	$(document).on('keyup', function(event) {
		// Close modal on “Esc”
		if (event.keyCode == 27 && $searchContainer.is(':visible')) {
			closeSearch();
		}
	});

	// Submit form on enter
	$inputSearch.on('keydown', function(event) {
		if (event.keyCode == 13) {
			$formSearch.submit();
		}
	});

}

$(document).ready(searchEvents());